<template>
  <div class="count-down-wrapper" :class="getClassName()">
    <span class="num h-num">{{ hour }}</span
    ><i>时</i><span class="num m-num">{{ minute }}</span
    ><i>分</i><span class="num s-num">{{ second }}</span
    ><i>秒</i>
  </div>
</template>

<script>
export default {
  name: "CruiseCountDown",
  props: {
    countDownNum: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    className: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      hour: "00",
      minute: "00",
      second: "00",
    };
  },
  created() {
    this.beginCountDown();
  },
  methods: {
    fixedTime(time) {
      if (time < 10) {
        return "0" + time;
      }
      return time + "";
    },
    beginCountDown() {
      const endDate = new Date(this.countDownNum).getTime();
      const curDate = new Date().getTime();
      const totalSeconds = parseInt((endDate - curDate) / 1000);
      if (totalSeconds >= 0) {
        this.hour = this.fixedTime(Math.floor(totalSeconds / 60 / 60));
        this.minute = this.fixedTime(Math.floor((totalSeconds / 60) % 60));
        this.second = this.fixedTime(Math.floor(totalSeconds % 60));
        const self = this;
        setTimeout(() => {
          self.beginCountDown();
        }, 1000);
      }
    },
    getClassName() {
      let className = {};
      if (this.className && this.className.length > 0) {
        className[this.className] = true;
      }
      return className;
    },
  },
};
</script>

<style lang="less" scoped>
.count-down-wrapper {
  display: inline;
}

.count-down-wrapper span:first-child {
  font-size: 18px;
}
.count-down-wrapper span:nth-child(2) {
  font-size: 14px;
}
.count-down-wrapper span span {
  position: relative;
  top: -2px;
}
.count-down-wrapper.timing span.num {
  color: #ffa70d;
  font-size: 24px;
  font-weight: 400;
}
</style>